export default __webpack_public_path__ + "static/media/Resooe.fe6930a8.png";